import React from 'react';
import { Link } from 'react-router-dom';

export const HubLogo = () => (
  <Link to="/" data-testid="hub-logo" className="inline-flex flex-col items-center group">
    <span className="text-2xl font-serif font-bold tracking-tight text-white group-hover:text-amber-400 transition-colors">
      CAPITOL VIEW
    </span>
    <span className="text-[10px] font-light tracking-[0.35em] uppercase text-amber-400 -mt-0.5">Stays</span>
  </Link>
);

export const HubEmailFooter = () => (
  <p data-testid="hub-email-legal" className="text-slate-500 text-xs text-center mt-4 leading-relaxed">
    We respect your inbox. You can unsubscribe at any time using the link in any of our emails, or by
    emailing{' '}
    <a href="mailto:capitolviewstays@gmail.com?subject=Unsubscribe" data-testid="hub-unsubscribe-link" className="text-amber-400 underline">
      capitolviewstays@gmail.com
    </a>
    . See our{' '}
    <Link to="/privacy" data-testid="hub-privacy-link" className="text-amber-400 underline">Privacy Policy</Link>.
  </p>
);

const QR_LOGO_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120"><rect width="120" height="120" rx="18" fill="#0f172a"/><rect x="6" y="6" width="108" height="108" rx="14" fill="none" stroke="#f59e0b" stroke-width="4"/><text x="60" y="72" text-anchor="middle" font-family="Georgia, serif" font-size="46" font-weight="700" fill="#f59e0b">CV</text><text x="60" y="94" text-anchor="middle" font-family="Arial, sans-serif" font-size="11" letter-spacing="3" fill="#ffffff">STAYS</text></svg>`;

export const QR_LOGO_DATA_URI = `data:image/svg+xml;base64,${btoa(QR_LOGO_SVG)}`;
